function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.93 31C43.982 31 31 43.983 31 59.93c0 15.945 12.983 28.928 28.93 28.928 15.945 0 28.928-12.983 28.928-28.929C88.858 43.983 75.875 31 59.93 31zm0 54.35c-13.998 0-25.382-11.385-25.382-25.382 0-13.997 11.384-25.381 25.381-25.381S85.31 45.97 85.31 59.968 73.926 85.35 59.93 85.35z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.048 48.428a2.962 2.962 0 01-2.963 2.963 2.962 2.962 0 01-2.963-2.963 2.962 2.962 0 012.963-2.963c1.638-.04 2.963 1.286 2.963 2.963zM60.085 56.264c-.975 0-1.794.78-1.794 1.794v15.127c0 .975.78 1.793 1.794 1.793.975 0 1.793-.78 1.793-1.793V58.058c0-1.014-.78-1.794-1.793-1.794z",
  fill: "#00BAC3"
});

function SvgCircleInformation(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCircleInformation;